import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type GetUsageReportPayload = Parameters<ReturnType<typeof getPrivateApi>['getUsageReport']>[0];

export function useGetUsageReport(options?: UseMutationOptions<Blob, unknown, GetUsageReportPayload>) {
  return useMutation(
    ['usage-report'],
    async (payload) => {
      const privateApi = getPrivateApi();
      const reportId = payload?.reportId;

      const usageReport = await privateApi.getUsageReport({
        reportId,
      });

      return usageReport;
    },
    options,
  );
}
